import { render } from "./NotificationAlertComponent.vue?vue&type=template&id=6f71474a"
import script from "./NotificationAlertComponent.vue?vue&type=script&lang=js"
export * from "./NotificationAlertComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/NotificationAlert/NotificationAlertComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f71474a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f71474a', __exports__)) {
    api.reload('6f71474a', __exports__)
  }
  
  module.hot.accept("./NotificationAlertComponent.vue?vue&type=template&id=6f71474a", () => {
    api.rerender('6f71474a', render)
  })

}


export default __exports__